var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LeadStatusesPage',{attrs:{"title":`${_vm.__('bloqueio', 'settings')} - ${_vm.__(
    'automatização',
    'settings'
  )}`,"description":_vm.__('define quais status são bloqueados para automatização', 'settings'),"param-id":"leads_block_statuses_automation"}})
}
var staticRenderFns = []

export { render, staticRenderFns }